import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

// SHARED
import ModuleTitleBar from "Components/shared/module-title-bar/module-title-bar";

//SERVICES
import { fetchTrolleyParcel } from "Services/delivery.services";

//SCSS
import "../parcel-tracking-view.scss";

//HELPERS
import { decode, toaster } from "Helpers/index";

import ParcelTrackingTrolleyViewComponent from "Components/delivery-management/parcel-tracking-view/trolley-view-component";
import useQuery from "Hooks/query.hook";

const ParcelTrackingTrolleyViewPage = ({}) => {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const decodedTrolleyID = decode(id);
  const [trolleyDetails, setTrolleyDetails] = useState<any>({});

  const query = useQuery();
  const redirect = query.get("redirect");

  useEffect(() => {
    fetchTrolleyDetails();
  }, []);

  const fetchTrolleyDetails = async () => {
    const responseData = await fetchTrolleyParcel(decodedTrolleyID);
    if (responseData && !responseData.error) {
      setTrolleyDetails(responseData);
    } else {
      toaster("error", "Cannot fetch trolley");
    }
  };

  return (
    <div>
      <Helmet>
        <title>{t("title.deliveryManagement")}</title>
      </Helmet>

      <ModuleTitleBar
        titleText={t("title.deliveryManagement")}
        haveSubtitle
        subtitleText={
          redirect ? (redirect == "sort" ? t("title.sorting") : t("title.enroute")) : ""
        }
      />
      <ParcelTrackingTrolleyViewComponent info={trolleyDetails} />
    </div>
  );
};

export default ParcelTrackingTrolleyViewPage;
